/*
  Ported from src/pages/CartPage.tsx, wired to Shopify's real Ajax Cart API
  (/cart/change.js) instead of the old fake localStorage cart. Real Shopify
  Checkout replaces the previous "commande confirmée" fake screen entirely —
  the one deliberate divergence from the Cloudflare build, since that site
  never had a real checkout to begin with.
*/
(function () {
  function init(root) {
    root.querySelectorAll('[data-cart-line]').forEach(function (line) {
      var key = line.getAttribute('data-cart-line');
      var input = line.querySelector('[data-cart-qty-input]');
      var minus = line.querySelector('[data-cart-qty-minus]');
      var plus = line.querySelector('[data-cart-qty-plus]');
      var remove = line.querySelector('[data-cart-remove]');

      function change(quantity) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity }),
        }).then(function () {
          window.location.reload();
        });
      }

      if (minus) minus.addEventListener('click', function () { change(Math.max(0, parseInt(input.value, 10) - 1)); });
      if (plus) plus.addEventListener('click', function () { change(parseInt(input.value, 10) + 1); });
      if (remove) remove.addEventListener('click', function () { change(0); });
    });
  }

  document.querySelectorAll('[data-oblivion-cart]').forEach(init);
})();
